<template>
  <div>
    <datetime
      @input ="send"
      :phrases="phrases"
      format="dd-MM-yyyy HH:mm"
      type="datetime"
      :required="required"
      :minute-step="5"
      :input-id="name"
      :name="name"
      input-class="form-control form-control-sm mb-2"
      v-model="post"
    ></datetime>
  </div>
</template>

<script>
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  props: ["name", "validation", "content"],
  data() {
    return {
      post: this.content && !this.content.includes('T') ? this.content.replace(' ', 'T') : this.content,
      phrases: {
        ok: "Pilih",
        cancel: "Batal"
      }
    };
  },
  components: {
    Datetime
  },
  computed: {
    required() {
      if (this.validation == "required") {
        return true;
      }

      return false;
    }
  },
  methods: {
    send() {
      if (this.post != '') 
      {
        var arm = this.$moment(this.post).format('YYYY-MM-DD HH:mm');
      }

      this.$emit("post", {
        name: this.name,
        value: arm
      });
    }
  }
};
</script>